/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { a as _arrayWithHoles, b as _nonIterableRest } from './dep-1ec078b3.mjs';
import { a as _iterableToArray } from './dep-be6b014c.mjs';
import { a as _unsupportedIterableToArray } from './dep-558fadc3.mjs';

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}

export { _toArray as _ };
//# sourceMappingURL=dep-dbbdd44f.mjs.map
